import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SelectItem} from '@tj/tj-dmp-lib-api';
import {AbstractEditorComponent} from '../abstract-editor.component';
import {ValueEditor} from '../value-editor';
import {FormBuilder} from '@angular/forms';
import {ValidatorEditorService} from "../validator-editor.service";

@Component({
    selector: 'dmp-civility-editor',
    templateUrl: './civility-editor.component.html',
    styleUrls: ['../editor.component.scss'],
    standalone: false
})
export class CivilityEditorComponent extends AbstractEditorComponent implements OnInit {
    items: SelectItem[] = [];

    constructor(protected translate: TranslateService,
                protected fb: FormBuilder,
                protected validatorService: ValidatorEditorService) {
        super(fb, validatorService);
    }
    transformBeforeSave(value: any) {
        return value;
    }

    ngOnInit(): void {
        this.value = this.value ? this.value.toUpperCase() : null;
        this.init();
        this.items = [{
            label: this.translate.instant('common.MRS'),
            value: 'MRS'
        }, {
            label: this.translate.instant('common.MR'),
            value: 'MR'
        }];
        this.disable = this.value === 'null';
    }
}
